import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

const ItnChip = ({ itn }) => (
  <Chip
    label={
      <Box direction="row" display="flex">
        <Typography sx={{ mr: 0.5 }} variant="caption">
          ITN:
        </Typography>
        <Typography sx={{ fontWeight: 400 }} variant="caption">
          {itn}
        </Typography>
      </Box>
    }
    sx={{
      '&. MuiChip-label.MuiChip-labelMedium ': { pr: 0 },
      borderRadius: '4px',
      height: 'auto',
      px: 0,
      py: 0.5,
    }}
  />
);

ItnChip.propTypes = {
  itn: PropTypes.string.isRequired,
};

export default ItnChip;
